import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/parkedVacations',
        name: 'parkedVacations',
        meta: { sideMenuLabel: "Depositi vacanze" },
        component: () => import("./views/parkedVacations.vue")
    },
    {
        path: '/parkedVacations/:identifier',
        name: 'parkedVacationDetail',
        meta: { classes: "" },
        component: () => import("./views/parkedVacationDetail.vue")
    }
];

export default routes;